import { render } from "./AlertTable.vue?vue&type=template&id=ca19bcae&scoped=true"
import script from "./AlertTable.vue?vue&type=script&lang=js"
export * from "./AlertTable.vue?vue&type=script&lang=js"

import "./AlertTable.vue?vue&type=style&index=0&id=ca19bcae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca19bcae"]])

export default __exports__